/** Personas that may host sessions included in coaching reports. */
export const COACHING_HOST_PERSONAS = [
  'InstitutionAdmin',
  'SiteAdmin',
  'Teacher',
  'TeachingAssistant'
] as const;

export type CoachingHostPersona = typeof COACHING_HOST_PERSONAS[number];

/**
 * What the coaching reports open with. Clearing the filter still means every
 * persona above.
 */
export const DEFAULT_COACHING_HOST_PERSONAS: readonly CoachingHostPersona[] = [
  'Teacher'
];
